import React, { useContext } from 'react';

import {
  StyledCard,
  StyledHeader,
  StyledContent,
  StyledAssignWrapper,
  StyledCardWrapper,
} from 'modules/assignment-cards/styled';

import { JourneysInfo } from 'modules/assignment-cards/components';

import DriverPoolContext from '../context';
import HeaderInfo from '../../assignment-cards/components/DriverHeaderInfo';

const DriverPoolCard = ({ id, vertical, assignActionComponent: AssignActionComponent = null }) => {
  const {
    fetchingJourneys,
    journeysByDriver = {},
    availableDriversById,
  } = useContext(DriverPoolContext);

  const driver = availableDriversById[id] || {};
  const driverJourneys = journeysByDriver[driver.id] || [];

  const { vehicle, trailer } = driver;

  const driverId = driver?.id;
  const vehicleIds = [(vehicle || {}).id, (trailer || {}).id];

  return (
    <StyledCardWrapper vertical={vertical}>
      <StyledCard data-testid="driverpool_card" vertical={vertical}>
        <StyledHeader>
          <HeaderInfo
            driver={driver}
            driverJourneys={driverJourneys}
            fetchingJourneys={fetchingJourneys}
          />
        </StyledHeader>
        <StyledContent vertical={vertical}>
          {!!AssignActionComponent && (
            <StyledAssignWrapper>
              <AssignActionComponent driverId={driverId} vehicleIds={vehicleIds} />
            </StyledAssignWrapper>
          )}
          <JourneysInfo
            id={id}
            fetching={fetchingJourneys}
            journeys={(journeysByDriver || {})[driverId]}
          />
        </StyledContent>
      </StyledCard>
    </StyledCardWrapper>
  );
};

export default DriverPoolCard;
